/*!
 * Manera Contact
 * 
 */
$(document).ready(function(){
   var form = $('.contact__form,.nl__form ');
   var widgets = form.find('.widget-text input,.widget-select select');

   widgets.focus(function(){
       $(this).parent().addClass('active complete');
   }).blur(function(){
       if($(this).val() == "")
           $(this).parent().removeClass('active complete');
   });

   $('.meetus .linkdecoration').on('click',function(){
       TweenMax.to(window,1, {scrollTo:".contact__form"});
   });

});